export default "__VITE_ASSET__983b871f__"